<div class="similar-inquiries-md-calendar-head"></div>

<div
  class="similar-inquiries-md-calendar-body"
  #scrollBody
  (scroll)="onBodyScroll()"
>
  <div
    class="similar-inquiries-md-calendar-grid"
    #scrollGrid
  >
    <div
      class="similar-inquiries-md-calendar-week"
      *ngFor="let group of weekGroups; trackBy: trackByGroup"
      [style.grid-row]="group.gridRow"
    >
      <span>{{ group.label }}</span>
    </div>

    <div
      class="similar-inquiries-md-calendar-day"
      *ngFor="let day of days; let rowIndex = index; trackBy: trackByDay"
      [class.similar-inquiries-md-calendar-weekend]="day.dateItem.isWeekend"
      [class.similar-inquiries-md-calendar-first-row]="rowIndex === 0"
      [class.today]="day.dateItem.isToday"
      [style.grid-row]="rowIndex + 1"
    >
      <span class="similar-inquiries-md-calendar-day-date">
        {{ day.dateItem.dateString | date: 'dd.MM.yy' }}
      </span>
      <span class="similar-inquiries-md-calendar-day-weekday">{{ day.dateItem.weekdayShort }}</span>
    </div>
  </div>
</div>

<base-customer-similar-inquiries-md-calendar-scroll
  [max]="scrollMax"
  [value]="scrollTop"
  (valueChange)="onScrollChange($event)"
></base-customer-similar-inquiries-md-calendar-scroll>
